import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';
import Footer from './Footer';
import { Menu, Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
// import Nothing_here from './Nothing_here';
import search from '../assets/images/search.png';
import addresses_image from '../assets/images/addresses-image.svg';
import Select from 'react-dropdown-select';
import current_location from '../assets/images/current-location.png';
import map from '../assets/images/map.png';
import map_marker from '../assets/images/map-marker.png';



import Headermain from './Headermain';
import Slidemenu from './Slidemenu';

const selectCity = [
    { label: 'Vadodara', value: 'Vadodara' },
    { label: 'Ahemdabad', value: 'Ahemdabad' },
    { label: 'Gandhinagar', value: 'Gandhinagar' }
]
const selectState = [
    { label: 'Gujarat', value: 'Gujarat' },
    { label: 'Maharashtra', value: 'Maharashtra' },
    { label: 'Madhya Pradesh', value: 'Madhya Pradesh' }
]


class Addresses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 'Gujarat'
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Credits, Promos & Gift Cards</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="banner-dropdown-search-box-wrapper use-loaction-header profile-location-dropdown">
                                    <div className="banner-dropdown-search-area">
                                        <div className="banner-location-dropdown">
                                            <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']} onClick={(e) => e.preventDefault()}>
                                                <a onClick={(e) => e.preventDefault()}>
                                                <Space>
                                                    Select Location
                                                    <DownOutlined />
                                                </Space>
                                                </a>
                                            </Dropdown>
                                        </div>
                                        <div className="banner-search-input-box" onClick={(e) => e.preventDefault()}>
                                            <span className="search-icon-box">
                                                <img src={search} alt="" />
                                            </span>
                                            <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                        </div>
                                    </div>
                                </div>
                                <Slidemenu prop={this.props} />
                                <div className="addresses common-content content">
                                    <h3>Addresses</h3>
                                    <a href="" title="Add a new address" data-bs-toggle="modal" data-bs-target="#exampleModal" className="add-address">Add New Address</a>
                                    <div className="address-wrapper">
                                        <div className="address-info">
                                            <div className="address-name">
                                                <h4>Amit Nagar</h4>
                                                {/* <span className="address-tag">Billing Address</span> */}
                                                <a href="" title="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</a>
                                            </div>
                                            <span className="location-text">43A, Amit Nagar, Jay Santhoshi Nagar, Karelibagh, Vadodara, Gujarat 390002</span>
                                        </div>
                                        <div className="address-info">
                                            <div className="address-name">
                                                <h4>Babajipura</h4>
                                                {/* <span className="address-tag">Shipping Address</span> */}
                                                <a href="" title="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</a>
                                            </div>
                                            <span className="location-text">24, Indu Heights, Babajipura, Vadodara, Gujarat 390001</span>
                                        </div>
                                        <div className="address-info">
                                        </div>
                                    </div>

{/* 
                                    <Nothing_here wrapperClass="common-nothing-wrapper no-addresses-wrapper" imageAreaClass="image-area-box" imgSrc={addresses_image} descriptionClass="common-nothing-description" descriptionText="No Address added yet" btnClass="common-nothing-btn add-member-btn" btnText="+ Add Address" modal="modal" modalTarget="#exampleModal"/> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="edit_form modal edit_address_form fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="exampleModalLabel">Edit Address</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <form id="address_form" className="popup_form" method="post">
                                    <div className="form-group">
                                        <label htmlFor="addressLine1" className="label">Address Line 1</label>
                                        <input type="text" name="name" className="form-control" required="required" placeholder='Amit Nagar, Jay Santhoshi Nagar' id="addressLine1"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="addressLine2" className="label">Address Line 2</label>
                                        <input type="text" name="name" className="form-control" required="required" placeholder='Karelibagh' id="addressLine2"/>
                                    </div>
                                    <div className="form-group select-dropdown-box">
                                        <label htmlFor="city" className="label">City</label>
                                        <Select className="form-control custom-select-dropdown" id="city" options={selectCity} placeholder='Vadodara' onChange={(value) => console.log(value)} />
                                    </div>
                                    <div className="form-group select-dropdown-box">
                                        <label htmlFor="state" className="label">State</label>
                                        <Select className="form-control custom-select-dropdown" id="state" options={selectState} placeholder='Gujarat' onChange={(value) => console.log(value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pincode" className="label">PIN Code</label>
                                        <input type="number" id="pincode" name="name" className="form-control" placeholder='390002' required="required" />
                                    </div>
                                    {/* <div className="form-group radio">
                                        <label className="radio-btn">Billing Address
                                            <input type="radio" name="radio" id="billing" />
                                            <span className="checkmark"></span>
                                        </label>
                                        <label className="radio-btn">Shipping Address
                                            <input type="radio" name="radio" id="shipping" />
                                            <span className="checkmark"></span>
                                        </label>
                                        <label className="radio-btn">Billing & Shipping Address
                                            <input type="radio" name="radio" id="both" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div> */}
                                    <div className="footer-btns">
                                        <button className="form_btn save">Save</button>
                                        <button className="form_btn del">Delete</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default Addresses;